module.exports = __webpack_public_path__ + "createstatic/media/hotspotimg.b399d846.png";